export default "__VITE_PUBLIC_ASSET__55918e73__"